import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormattingService } from '../../shared/services/formatting.service';
import { ModelAttributeSectionsConfig } from './model-attribute-sections.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'model-attribute-sections',
  templateUrl: './model-attribute-sections.component.html',
  styleUrls: ['./model-attribute-sections.component.scss'],
})
export class ModelAttributeSectionsComponent implements OnChanges, OnInit {
  @Input() config: ModelAttributeSectionsConfig;
  @Input() data: any;

  constructor(private formatService: FormattingService) {}

  ngOnChanges(change: SimpleChanges) {
    if (!change.firstChange) this.formatTabSections();
  }

  ngOnInit() {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config;
    this.data = data;
    this.formatTabSections();
  }

  private formatTabSections() {
    if (this.config.sections) {
      this.config.sections.forEach((section) => {
        if (section.attributes && section.attributes.length) {
          section.attributes = this.formatFieldsData(section.attributes);
        }
      });
    }
  }

  formatFieldsData(fieldArr: any) {
    return fieldArr
      .map((attr) =>
        this.formatService.formatConfigValueAsTemplate(attr, this.data),
      )
      .map((config) => config);
  }
}
